var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"wrap":"","align":"center","justify":"center"}},[_c('div',{staticClass:"about"},[_vm._v(" About the cabin... ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }